<template>
  <v-row class="row mx-2 my-0 ma-lg-0">
    <v-col cols="12" lg="8" class="order-lg-1 pa-0">
      <BaseSelect
        name="itemType"
        hideDetails
        :rules="{
          required: {
            required: true,
            fieldLabel: 'Item type',
          },
        }"
        v-if="possession.form?.itemTypes?.length"
        class="col-lg-12"
        :items="possession.form.itemTypes"
        :label="!$vuetify.breakpoint.lgAndUp ? 'Item type' : ''"
        v-model="possession.form.selectedItemType"
        :dense="$vuetify.breakpoint.lgAndUp"
      />
    </v-col>
    <v-col cols="12" class="order-lg-3 pa-0">
      <div class="d-flex align-start px-3">
        <v-icon :color="'psorange'" class="mr-2">mdi-alert</v-icon>
        <span>
          Some items, such as musical instruments like guitars, are not covered.
          Please review
          <a
            href="#"
            class="accent--text font-weight-bold"
            @click.prevent="$emit('showWhatsIncluded', possession.modalData)"
            >What's covered?</a
          >
          for more information.
        </span>
      </div>
    </v-col>
    <v-col cols="12" lg="10" class="order-lg-4 pa-0">
      <div class="d-flex flex-lg-row flex-wrap">
        <BaseInput
          name="itemDescription"
          :rules="{
            required: {
              required: true,
              fieldLabel: 'Description',
            },
          }"
          hideDetails
          :placeholder="
            $vuetify.breakpoint.lgAndUp
              ? 'Please provide a brief description of the item...'
              : ''
          "
          :label="
            !$vuetify.breakpoint.lgAndUp
              ? possession.form.descriptionFieldLabel
              : ''
          "
          v-model="possession.form.descriptionFieldValue"
          :class="[
            possession.form?.itemTypes?.length
              ? 'order-lg-2 flex-grow-1 col-lg-12 pb-2 pb-lg-0'
              : 'flex-grow-1 col-lg-12',
          ]"
          :dense="$vuetify.breakpoint.lgAndUp"
        />
      </div>
    </v-col>
    <v-col cols="12" lg="4" class="order-lg-2 pa-0">
      <BaseInput
        name="itemValue"
        :rules="{
          required: {
            required: true,
            fieldLabel: 'Item value',
          },
          regex: {
            required: true,
            fieldLabel: 'Item value',
            pattern: regexPattern,
            customMessage:
              'Value format is invalid - please enter whole pounds only.',
          },
          min_currency_value: {
            minValue: possession.form.valueFieldMinValue,
            fieldLabel: 'Item value',
          },
        }"
        hideDetails
        :label="
          !$vuetify.breakpoint.lgAndUp ? possession.form.valueFieldLabel : ''
        "
        class="col-lg-12 col-9"
        :dense="$vuetify.breakpoint.lgAndUp"
        prefix="£"
        v-model="possession.form.valueFieldValue"
        validationMode="lazy"
        moneyFormat
      />
    </v-col>

    <v-col
      cols="12"
      lg="2"
      class="order-lg-5 pt-3 mb-4 mb-lg-0 add-button__wrapper"
    >
      <BaseButton
        depressed
        name="add"
        text="ADD"
        rounded
        :height="$vuetify.breakpoint.lgAndUp ? '40' : '60'"
        block
        dense
        :color="'psorange'"
        class="font-weight-bold font-18"
        type="submit"
      />
    </v-col>
  </v-row>
</template>

<script>
import BaseButton from "@/components/BaseComponents/BaseButton";
import BaseInput from "@/components/BaseComponents/BaseInput";
import BaseSelect from "@/components/BaseComponents/BaseSelect";

export default {
  name: "LayoutDrawerCustomiseCoverFormSpecifiedItems",
  components: {
    BaseButton,
    BaseInput,
    BaseSelect,
  },
  props: {
    possession: {
      type: Object,
      required: true,
    },
    regexPattern: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
